import { cloneElement, lazy } from 'react';
import { useLazyComponentPreload } from '@medifind/hooks';
import { IconBolt } from '@medifind/icons';
import { useMFModal } from '@medifind/popups';
import { Button } from '@medifind/shared-basic-components';
import { logEventGA4, selectRouteParams, useRouteStore } from '@medifind/zustand';
import styles from './ClinicalTrialRequest.module.scss';

const ClinicalTrialRequestForm = lazy(() => import('./ClinicalTrialRequestForm'));

const ClinicalTrialRequest = ({ label, classes, location, contacts, trialName, children }) => {
  useLazyComponentPreload(ClinicalTrialRequestForm, 20000);

  const { articleId, projectId, codingName } = useRouteStore(selectRouteParams);
  const { MFModal, openModal, closeModal } = useMFModal();
  const handleClick = (event) => {
    logEventGA4('clinical_trial_request', { action: 'open' });
    openModal();
    event.preventDefault();
    event.stopPropagation();
  };

  const { orgName, city, stateProvince, countryCode, postalCode, country } = location || {};
  return (
    <>
      {children ? (
        cloneElement(children, { onClick: handleClick })
      ) : (
        <Button
          iconBefore={<IconBolt color="white" />}
          classes={classes}
          type="thin"
          color="red"
          onClick={handleClick}
          label={label || 'Contact Site'}
        />
      )}
      <MFModal
        title="CONNECT WITH A CLINICAL TRIAL'S LOCATION"
        secondaryTitle={
          location ? (
            <>
              <h4 className={styles['org-name']}>{orgName}</h4>
              <h5 className={styles['org-location']}>
                {city && `${city}, `}
                {stateProvince && `${stateProvince}, `}
                {countryCode && `${countryCode}, `}
                {postalCode && `${postalCode}`}
              </h5>
            </>
          ) : null
        }
      >
        <ClinicalTrialRequestForm onClose={closeModal} location={location} contacts={contacts} trialName={trialName} />
      </MFModal>
    </>
  );
};

export { ClinicalTrialRequest as default, ClinicalTrialRequest };
